import React, {useState} from "react";
import './index.scss'
import Service from '../../service'
import { Toast } from "antd-mobile";

const SyntheticConfirmModal = ({ onClose, successCallBack, clientId,miniOpenId,imgCode,wordCode}) => {
  const [success, setSuccess] = useState(false)
  const [count, setCount] = useState(0)
  const [date, setDate] = useState()
  const [loading, setLoading] = useState(false)

  const handleConfirm = async () => {
    try {
      setLoading(true)
      const params = {
        clientId: clientId,
        eventType: 1,
        imgCode,
        wordCode,
        ...(miniOpenId && { miniOpenId }),
      }
      console.log('params====>',params);
      const res = await Service.fragmentsCompoundService(
        params,
        true
      )
      if (res?.data) {
        setDate(res.data)
        setCount(res?.data?.count)
        setSuccess(true)
      }
    } catch (e) {
      console.error('合成失败:', e);
      Toast.show(typeof e === 'string' ? e : (e?.message || '合成失败，请重试'));
    } finally {
      setLoading(false)
    }
  }
  const handleKnow = () => {
    onClose()
    successCallBack && successCallBack()
  }
  return (
    <div className="synthetic-confirm-modal">
      <div className={`synthetic-confirm-container ${success ? 'success-container' : ''}`}>
        {!success && (
          <div className="synthetic-confirm">
            <div className="synthetic-confirm-close" onClick={onClose}></div>
            <div className="synthetic-confirm-msg">
              <div className="synthetic-confirm-question">合成后选择的图片将被销毁并</div>
              <div className="synthetic-confirm-question"> 获得一个新的藏品</div>
              <div className="synthetic-confirm-question">确认合成?</div>
            </div>
            <div className="synthetic-confirm-btn-box">
              <button className="synthetic-confirmBtn" onClick={handleConfirm} disabled={loading}>
                {loading ? '合成中...' : '确认合成'}
              </button>
            </div>
          </div>
        )}
        {success && (
          <div className="synthetic-success">
            <div className="synthetic-success-title">合成成功</div>
            <img className="synthetic-success-img" src={date?.imgUrl} alt="" />
            {/* {count > 1 && <div className="synthetic-success-count">x{count}</div>} */}
            <button className="synthetic-success-btn" onClick={handleKnow}>我知道了</button>
          </div>
        )}
      </div>
    </div>
  )
}
export default SyntheticConfirmModal